export enum Tasks {
  arrow1 = '0',
  arrow2 = '1',
  arrow3 = '2',
  arrow4 = '3',
  arrow5 = '4',
  arrow6 = '5',
}
